export function requireValidator<T>(message: string): (value: T) => string {
  return (value: T) => value ? '' : message;
}